export default {
  segments: state => state.segments,
  segmentsParams: state => state.segmentsParams,
  createSegmentModalIsActive: state => state.createSegmentModalIsActive,
  selectedSegmentForSend: state => state.selectedSegmentForSend,
  clientsInSelectedSegment: state => state.clientsInSelectedSegment,
  newSegmentForm: state => state.newSegmentForm,
}
